
import { useMutation, useQueryClient} from 'react-query'; 
import { useContext } from 'react';
import { AuthContext } from '../../../../Context/AuthContext';
import { useNavigate } from 'react-router-dom';

const useDeleteVehicle = () => {
  const queryClient = useQueryClient();
  const { token } = useContext(AuthContext); 
  const navigate = useNavigate(); 

  const deleteVehicle = useMutation(
    async (vid) => {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/charterer/vehicles/${vid}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`, 
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to delete vehicle');
      }

      return response.json();
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('vehicles');
        navigate('/vehicle'); 
      },
    }
  );

  return {
    deleteVehicle,
    isLoading: deleteVehicle.isLoading,
  };
};

export default useDeleteVehicle;

